import "./App.css";
import { useEffect, useState } from "react";
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {
  getAuth,
  signInWithPopup,
  onAuthStateChanged,
  GoogleAuthProvider,
  signOut,
} from "firebase/auth";
import {
  Box,
  Button,
  HStack,
  IconButton,
  useColorMode,
} from "@chakra-ui/react";
import { MoonIcon, SunIcon } from "@chakra-ui/icons";
import { getDatabase, ref, set, onValue, off } from "firebase/database";
import Session from "./pages/Session";
import Home from "./pages/Home";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBbXFE7LGiiCHe6BzIFo3yRDhxdNrrk4u4",
  authDomain: "studyhub-6bcc5.firebaseapp.com",
  projectId: "studyhub-6bcc5",
  databaseURL: "https://studyhub-6bcc5-default-rtdb.firebaseio.com/",
  storageBucket: "studyhub-6bcc5.appspot.com",
  messagingSenderId: "142798977797",
  appId: "1:142798977797:web:893d4efdd58b2e94b5956c",
  //eslint-disable-next-line no-template-curly-in-string
  measurementId: "${config.measurementId}",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
//eslint-disable-next-line no-unused-vars
const analytics = getAnalytics(app);
const provider = new GoogleAuthProvider();
const db = getDatabase(app);
provider.addScope("https://www.googleapis.com/auth/userinfo.profile");

// signInWithPopup(auth, provider)
//   .then((result) => {
//     // This gives you a Google Access Token. You can use it to access the Google API.
//     const credential = GoogleAuthProvider.credentialFromResult(result);
//     const token = credential.accessToken;
//     // ...
//   })
//   .catch((error) => {
//     // Handle Errors here.
//     const errorCode = error.code;
//     const errorMessage = error.message;
//     // The email of the user's account used.
//     const email = error.email;
//     // The AuthCredential type that was used.
//     const credential = GoogleAuthProvider.credentialFromError(error);
//     // ...
//   });

function App() {
  const [user, setUser] = useState(null);
  const [uid, setUID] = useState(null);
  const [loggedIn, setLoggedIn] = useState(null);
  const [session, setSession] = useState(null);
  const auth = getAuth();

  const { colorMode, toggleColorMode } = useColorMode();

  const logIn = async (e) => {
    await signInWithPopup(auth, provider);
  };

  const logOut = async (e) => {
    await signOut(auth);
  };

  useEffect(() => {
    //signOut(auth);
    onAuthStateChanged(auth, async (userAuth) => {
      if (userAuth) {
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/firebase.User
        setUser(userAuth);
        setUID(userAuth.uid);
        setLoggedIn(true);

        onValue(ref(db, "users/" + userAuth.uid + "/session"), (snapshot) => {
          if (snapshot.exists()) {
            setSession(snapshot.val());
            const sessionActiveRef = ref(
              db,
              "sessions/" + snapshot.val() + "/active"
            );
            onValue(sessionActiveRef, (active) => {
              if (active.exists()) {
                if (!active.val()) {
                  set(
                    ref(db, "users/" + userAuth.uid + "/lastSession"),
                    snapshot.val()
                  );
                  set(ref(db, "users/" + userAuth.uid + "/session"), "none");
                  off(sessionActiveRef);
                }
              }
            });
          } else {
            set(ref(db, "users/" + userAuth.uid), {
              session: "none",
              name: userAuth.displayName,
            });
            setSession("none");
          }
        });
      } else {
        // User is signed out
        setLoggedIn(false);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box>
      {loggedIn == null ? null : !loggedIn ? (
        <Button colorScheme="blue" onClick={logIn}>
          Sign In with Google
        </Button>
      ) : (
        <Box w="full">
          <HStack
            justifyContent="flex-end"
            p={2}
            bg={colorMode === "light" ? "gray.100" : "gray.800"}
            borderBottom="1px"
            borderColor={colorMode === "light" ? "gray.300" : "gray.500"}
          >
            <IconButton
              onClick={toggleColorMode}
              icon={colorMode === "light" ? <MoonIcon /> : <SunIcon />}
            />
            <Button colorScheme="blue" onClick={logOut}>
              Logout
            </Button>
          </HStack>
          {session === "none" ? (
            <Home user={user} uid={uid} db={db} />
          ) : (
            <Session id={session} uid={uid} db={db} user={user} />
          )}
        </Box>
      )}
    </Box>
  );
}

export default App;
